<template>
  <div>
    <b-table
      small
      :fields="fields"
      :items="data.qualityControl"
      responsive="sm"
      striped
    >
      <!-- A virtual column -->
      <template #cell(#)="data">
        {{ data.index + 1 }}
      </template>

      <!-- A custom formatted column -->
      <template #cell(name)="data">
        {{ data.value.first }}
      </template>

      <!-- A custom formatted column -->
      <template #cell(Popularity)="data">
        <b-progress
          :value="data.value.value"
          max="100"
          :variant="data.value.variant"
          striped
        />
      </template>

      <template #cell(reading1)="data">
        <b-form-input
          id="reading1"
          type="number"
          :value="data.value"
          @change="readingOneUpdated(data.item.id, $event)"
        />
      </template>

      <template #cell(reading2)="data">
        <b-form-input
          id="reading2"
          type="number"
          :value="data.value"
          @change="readingTwoUpdated(data.item.id, $event)"
        />
      </template>

      <template #cell(status)="data">
        <b-form-select
          v-model="data.item.status"
          :options="optionQC"
          @change="readingQc(data.item.id, $event)"
        />
      </template>

      <template #cell(view_document)="row">
        <b-form-checkbox
          v-model="row.detailsShowing"
          plain
          class="vs-checkbox-con"
          @change="row.toggleDetails"
        >
          <span class="vs-checkbox"> </span>
          <span class="vs-label">{{
            row.detailsShowing ? "Hide" : "Show"
          }}</span>
        </b-form-checkbox>
      </template>

      <template #row-details="row">
        <b-row class="mb-2">
          <b-col md="3" class="mb-1">
            <b-form-file
              ref="fileInput"
              placeholder="Choose a file or drop it here..."
              drop-placeholder="Drop file here..."
              multiple
              class="d-none"
              @change="handleFileUpload"
            />
            <b-button variant="primary" @click="openFilePicker"
              >Upload Document</b-button
            >
          </b-col>
        </b-row>

        <b-row>
          <b-col md="3">
            <b-card class="custom-card mb-5">
              <b-card-header class="justify-content-end px-0">
                <b-dropdown
                  variant="link"
                  no-caret
                  class="chart-dropdown"
                  toggle-class="p-0"
                >
                  <template #button-content>
                    <feather-icon
                      icon="MoreVerticalIcon"
                      size="18"
                      class="text-body cursor-pointer"
                    />
                  </template>
                  <b-dropdown-item v-b-modal.modal-document>
                    View
                  </b-dropdown-item>
                  <b-dropdown-item href="#"> Download </b-dropdown-item>
                  <b-dropdown-item href="#"> Delete </b-dropdown-item>
                </b-dropdown>
              </b-card-header>

              <!-- body -->
              <b-card-body>
                <b-row class="justify-content-center align-items-center">
                  <b-col
                    md="6"
                    class="d-flex flex-column justify-content-center align-items-center text-center"
                  >
                    <feather-icon icon="FolderIcon" size="50" />
                    <b-card-text>document1.pdf</b-card-text>
                  </b-col>
                </b-row>
              </b-card-body>
              <!--/ body -->
            </b-card>
          </b-col>
          <b-col md="3">
            <b-card class="custom-card mb-5">
              <b-card-header class="justify-content-end px-0">
                <b-dropdown
                  variant="link"
                  no-caret
                  class="chart-dropdown"
                  toggle-class="p-0"
                >
                  <template #button-content>
                    <feather-icon
                      icon="MoreVerticalIcon"
                      size="18"
                      class="text-body cursor-pointer"
                    />
                  </template>
                  <b-dropdown-item v-b-modal.modal-document>
                    View
                  </b-dropdown-item>
                  <b-dropdown-item href="#"> Download </b-dropdown-item>
                  <b-dropdown-item href="#"> Delete </b-dropdown-item>
                </b-dropdown>
                <b-modal
                  id="modal-document"
                  ok-only
                  ok-title="Document"
                  centered
                  size="lg"
                  title="Document"
                  :hide-footer="true"
                >
                  <ViewDocument @refresh="refreshData" />
                </b-modal>
              </b-card-header>

              <!-- body -->
              <b-card-body>
                <b-row class="justify-content-center align-items-center">
                  <b-col
                    md="6"
                    class="d-flex flex-column justify-content-center align-items-center text-center"
                  >
                    <feather-icon icon="FolderIcon" size="50" />
                    <b-card-text>document2.pdf</b-card-text>
                  </b-col>
                </b-row>
              </b-card-body>
              <!--/ body -->
            </b-card>
          </b-col>
        </b-row>

        <b-button
          size="sm"
          variant="outline-secondary"
          @click="row.toggleDetails"
        >
          Hide Details
        </b-button>
      </template>

      <template #cell(dateStarted)="data">
        <b-form-input>
          {{ data.value }}
        </b-form-input>
      </template>
      <!-- A virtual composite column -->
      <template #cell(expectedDate)="data">
        <b-form-input>
          {{ data.value }}
        </b-form-input>
      </template>
    </b-table>
  </div>
</template>

<script>
import {
  BTable,
  BProgress,
  BBadge,
  BDropdown,
  BDropdownItem,
  BFormInput,
  BFormSelect,
  BFormCheckbox,
  BFormFile,
  BRow,
  BCol,
  BFormGroup,
  BPagination,
  BInputGroup,
  BCard,
  BCardHeader,
  BCardTitle,
  BCardText,
  BCardBody,
  BInputGroupAppend,
  BButton,
  BSpinner,
  BContainer,
} from "bootstrap-vue";
import ViewDocument from "../ViewDocument.vue";
export default {
  components: {
    BTable,
    BFormInput,
    BProgress,
    BDropdownItem,
    BDropdown,
    BBadge,
    BFormSelect,
    BFormCheckbox,
    BFormFile,
    BRow,
    BCol,
    BFormGroup,
    BPagination,
    BInputGroup,
    BCard,
    BCardHeader,
    BCardTitle,
    BCardText,
    BCardBody,
    BInputGroupAppend,
    BButton,
    BSpinner,
    BContainer,
    ViewDocument,
  },
  data() {
    return {
      optionQC: [
        { value: "0", text: "Rejected" },
        { value: "1", text: "Accepted" },
      ],
      buttonTitle: "Accepted",
      fields: [
        // A virtual column that doesn't exist in items
        "#",
        // A column that needs custom formatting
        { key: "operationSteps", label: "Operation Step" },
        { key: "qualityName", label: "Quality Name" },

        // A regular column
        { key: "minValue", label: "Minimum Value" },
        { key: "maxValue", label: "Maximum Value" },
        // A regular column
        { key: "reading1", label: "Reading 1" },
        { key: "reading2", label: "Reading 2" },
        { key: "status", label: "Quality Status" },
        { key: "view_document", label: "Documents" },

        // A virtual column made up from two fields
      ],
      items: [
        {
          operationSteps: "Operation Name 1",
          qualityName: "1",
          minValue: "1",
          maxValue: "1",
          reading1: "1",
          reading2: "1",
          status: "1",
        },
      ],
    };
  },
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  methods: {
    readingQc(id, value) {
      this.data.qualityControl.forEach((obj) => {
        if (obj.id === id) {
          obj.status = value;
        }
      });
    },
    readingOneUpdated(id, value) {
      this.data.qualityControl.forEach((obj) => {
        if (obj.id === id) {
          obj.reading1 = value;
        }
      });
    },
    readingTwoUpdated(id, value) {
      this.data.qualityControl.forEach((obj) => {
        if (obj.id === id) {
          obj.reading2 = value;
        }
      });
    },

    openFilePicker() {
      // Trigger click event of the hidden file input
      this.$refs.fileInput.$el.querySelector("input").click();
    },
    handleFileUpload(event) {
      // Handle file upload here
      console.log("Uploaded files:", event.target.files);
      // You can perform further processing here as needed
    },
  },
};
</script>
